import {
  getPictogramProgress,
  getPowerPlantProgress,
  getPictogramProgressDataset,
} from '../api'

// Servicios de progreso del parque solar. Encapsulan la llamada al api y la
// transformación de datos; el componente solo recibe el resultado ya listo para
// pintar (regla: componente → servicio → api).

// Progreso de un pictograma → { data, progress } (progress = array por capa).
export async function fetchPictogramProgress(pictogramId) {
  const response = await getPictogramProgress(pictogramId)
  const data = response.data.data

  const progress = [
    { name: 'pilings',    total: data.total_piling,     executed: data.executed_piling,     data: { 'Progreso total': data.progress_piling } },
    { name: 'structures', total: data.total_structures, executed: data.executed_structures, data: { 'Progreso total': data.progress_structures } },
    { name: 'modules',    total: data.total_modules,    executed: data.executed_modules,    data: { 'Progreso total': data.progress_modules } },
  ]

  return { data, progress }
}

// Progreso del power plant → { data, totalProgress } (promedio de los pictogramas).
export async function fetchPowerPlantProgress(projectId) {
  const response = await getPowerPlantProgress(projectId)
  const data = response.data.data

  const count = data.pictograms.length
  const sum = data.pictograms.reduce((acc, el) => acc + el.progress, 0)
  const totalProgress = sum / (count === 0 ? 1 : count)

  return { data, totalProgress }
}

// Dataset de progreso (para el gráfico) de un pictograma.
// → { success, pictogram, dataset } o { success: false, msg }.
export async function fetchPictogramProgressDataset(pictogramId) {
  const response = await getPictogramProgressDataset(pictogramId)

  if (!response.data.success) {
    return { success: false, msg: response.data.msg }
  }

  return {
    success: true,
    pictogram: response.data.data.pictogram,
    dataset: response.data.data.dataset,
  }
}
